import styled from "@emotion/styled";
import * as React from "react";

import { Pagination } from "components/pagination";
import { addCommas, plural } from "utils/string";

interface IProps {
  currentPage: number;
  totalPages: number;
  totalResults: number;
  onPageChange(page: number): void;
}

const Wrapper = styled.div`
  display: flex;
  min-height: 31px;
  border: 1px solid
    ${
      // FIXME: Fix this the next time the file is edited.
      // eslint-disable-next-line @typescript-eslint/explicit-function-return-type, @typescript-eslint/no-explicit-any
      (props: any) => props.theme.borderColor
    };
  border-width: 1px 0;
`;

const TotalResults = styled.div`
  flex: 1;
  display: flex;
  padding: 0 10px;
  align-items: center;
  font-size: 14px;
  color: ${
    // FIXME: Fix this the next time the file is edited.
    // eslint-disable-next-line @typescript-eslint/explicit-function-return-type, @typescript-eslint/no-explicit-any
    (props: any) => props.theme.primaryColor80
  };
`;

export const SubscriptionInvoicesPagination: React.FC<IProps> = ({
  currentPage,
  totalPages,
  totalResults,
  onPageChange,
}) => (
  <Wrapper>
    <TotalResults>
      {addCommas(totalResults)} {plural(totalResults, "invoice", "invoices")}
    </TotalResults>
    <Pagination currentPage={currentPage} totalPages={totalPages} totalPagesLimit={4000} onPageChange={onPageChange} />
  </Wrapper>
);
